"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SameSubjectEvaluationHandler = void 0;
const pex_models_1 = require("@sphereon/pex-models");
const jsonpath_1 = __importDefault(require("jsonpath"));
const ConstraintUtils_1 = require("../../ConstraintUtils");
const abstractEvaluationHandler_1 = require("./abstractEvaluationHandler");
class SameSubjectEvaluationHandler extends abstractEvaluationHandler_1.AbstractEvaluationHandler {
    constructor(client) {
        super(client);
        this.fieldIds = [];
        this.sameSubject = [];
        this.messages = new Map();
        this.messages.set(ConstraintUtils_1.Status.INFO, 'The field ids requiring the same subject to belong to same subject');
        this.messages.set(ConstraintUtils_1.Status.WARN, 'The field ids preferring the same subject to belong to same subject');
        this.messages.set(ConstraintUtils_1.Status.ERROR, 'The fields ids not belong to the same subject');
    }
    getName() {
        return 'SameSubjectEvaluation';
    }
    handle(pd, wrappedVcs) {
        const sameSubjectInDesc = this.mapSameSubjectFieldIdsToInputDescriptors(pd);
        const handlerCheckResults = this.mapCredentialsToResultObjecs(wrappedVcs, sameSubjectInDesc);
        const fieldIdOccurrencesCount = this.countSameSubjectOccurrences(sameSubjectInDesc, handlerCheckResults);
        this.generateErrorResults(fieldIdOccurrencesCount, handlerCheckResults);
        this.updatePresentationSubmission(pd);
    }
    mapSameSubjectFieldIdsToInputDescriptors(pd) {
        this.fieldIds.push(...jsonpath_1.default.nodes(pd, '$..fields[*].id'));
        this.sameSubject.push(...jsonpath_1.default.nodes(pd, '$..same_subject[*]'));
        const results = [];
        this.fieldIds.forEach((f) => {
            const sameSubject = this.sameSubject.find((ss) => ss.value.field_id.includes(f.value));
            if (sameSubject) {
                results.push([f, sameSubject]);
            }
        });
        return results;
    }
    generateErrorResults(fieldIdOccurrencesCount, handlerCheckResults) {
        fieldIdOccurrencesCount.forEach((v, k) => {
            const results = handlerCheckResults
                .filter((r) => k === r.payload.fieldIdSet)
                .map((r) => r.payload.credentialSubject.id);
            if (results.length !== v || new Set(results).size !== 1) {
                handlerCheckResults.forEach((v, i, arr) => {
                    if (v.payload.fieldIdSet === k) {
                        v.status = ConstraintUtils_1.Status.ERROR;
                        v.message = this.messages.get(ConstraintUtils_1.Status.ERROR);
                        arr[i] = v;
                    }
                });
            }
        });
        this.client.results.push(...handlerCheckResults);
    }
    countSameSubjectOccurrences(sameSubjectInDesc, handlerCheckResults) {
        const fieldIdOccurrencesCount = new Map();
        sameSubjectInDesc.forEach((s) => {
            const result = handlerCheckResults.filter((c) => s[1].value.field_id === c.payload.fieldIdSet);
            if (result) {
                if (fieldIdOccurrencesCount.has(s[1].value.field_id) && fieldIdOccurrencesCount.get(s[1].value.field_id)) {
                    fieldIdOccurrencesCount.set(s[1].value.field_id, fieldIdOccurrencesCount.get(s[1].value.field_id) + 1);
                }
                else {
                    fieldIdOccurrencesCount.set(s[1].value.field_id, 1);
                }
            }
        });
        return fieldIdOccurrencesCount;
    }
    mapCredentialsToResultObjecs(wrappedVcs, results) {
        const subjects = [
            ...jsonpath_1.default.nodes(wrappedVcs.map((wvc) => wvc.internalCredential), '$..credentialSubject'),
        ];
        const handlerCheckResults = [];
        subjects.forEach((s) => {
            const result = results.find((id) => jsonpath_1.default.query(s.value, `$..${id[0].value}`).length !== 0);
            if (result && result[1].value.directive === pex_models_1.Optionality.Required) {
                handlerCheckResults.push({
                    input_descriptor_path: jsonpath_1.default.stringify(result[0].path.slice(0, 3)),
                    status: ConstraintUtils_1.Status.INFO,
                    evaluator: this.getName(),
                    payload: { fieldIdSet: result[1].value.field_id, credentialSubject: s.value },
                    message: this.messages.get(ConstraintUtils_1.Status.INFO),
                    verifiable_credential_path: jsonpath_1.default.stringify(s.path.slice(0, 2)),
                });
            }
            else if (result && result[1].value.directive === pex_models_1.Optionality.Preferred) {
                handlerCheckResults.push({
                    input_descriptor_path: jsonpath_1.default.stringify(result[0].path.slice(0, 3)),
                    status: ConstraintUtils_1.Status.WARN,
                    evaluator: this.getName(),
                    payload: { fieldIdSet: result[1].value.field_id, credentialSubject: s.value },
                    message: this.messages.get(ConstraintUtils_1.Status.WARN),
                    verifiable_credential_path: jsonpath_1.default.stringify(s.path.slice(0, 2)),
                });
            }
        });
        return handlerCheckResults;
    }
}
exports.SameSubjectEvaluationHandler = SameSubjectEvaluationHandler;
